export enum AllProjectsView {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}
